// =====================================
//
//   Cart Controller
//   Author: Gray
//   createtime: 2016 / 09 / 01
//
// =====================================

window.InifECMobileApp.controller("CartController", ['$scope', '$state', '$timeout', '$rootScope', 'UserService', 'ShoppingCartService', 'OrderService', '$PreviousState', '$stateParams', '$InifECGA', 'BusinessMemberService', 'BonusPointsService', 'ProductDeliveryService', 'ProductUtil',
	function($scope, $state, $timeout, $rootScope, UserService, ShoppingCartService, OrderService, $PreviousState, $stateParams, $InifECGA, BusinessMemberService, BonusPointsService, ProductDeliveryService, ProductUtil) {

        // -------------------------------
        // [private] 取得購物車資料
        // -------------------------------
        var getShoppingCart = function() {

            if($scope.isLoading) {
                return;
            }

            $scope.isLoading = true;
            ShoppingCartService.getShoppingCart().then(function(result){

                if(result) {

                    // 一般商品
                    if(Array.isArray(result.defaultCart) && result.defaultCart.length > 0) {
                        formatShoppingCart($scope.defaultCart, result.defaultCart);
                    }

                    // 設計商品（需先報價）
                    if(Array.isArray(result.designCart) && result.designCart.length > 0) {
                        formatShoppingCart($scope.designCart, result.designCart);
                    }

                    // 急件商品
                    if(Array.isArray(result.emergencyCart) && result.emergencyCart.length > 0) {
                        formatShoppingCart($scope.emergencyCart, result.emergencyCart);
                    }

                    if($scope.defaultCart.length > 0) {
                        _changeCartType(ShoppingCartService.cartTypeMap.defaultCart);
                    } else if($scope.designCart.length > 0) {
                        _changeCartType(ShoppingCartService.cartTypeMap.designCart);
                    } else if($scope.emergencyCart.length > 0) {
                        _changeCartType(ShoppingCartService.cartTypeMap.emergencyCart);
                    } else {
                        _changeCartType(ShoppingCartService.cartTypeMap.defaultCart);
                    }

                    getTotalItemSize();
                    initDelivery();
                }

                $scope.isLoading = false;
            }, function(error){
                $scope.isError = true;
                $scope.isLoading = false;
            });
        }

        var formatShoppingCart = function(cartitems, items) {

            var newitems = [];

            for(var i = 0 ; i < items.length ; i++) {
                var orderitem = items[i];

                // 若是從歷史紀錄加到此檔案將會已經存在檔案
                if(orderitem.file) {
                    orderitem.orgFile = orderitem.file;
                    orderitem.orgFile.name = orderitem.orgFile.filename;
                    orderitem.file = undefined;
                    orderitem.userfile = undefined;
                }

                for(var j = 0; j < cartitems.length; j++) {
                    if(orderitem.orderitemid == cartitems[j].orderitemid) {
                        orderitem.userfile = cartitems[j].userfile;
                    }
                }

                newitems.push(orderitem);
            }

            cartitems.length = 0;
            Array.prototype.push.apply(cartitems, newitems);

            return cartitems.length;
        }

        var getTotalItemSize = function() {

            $scope.totalItemSize = 0;
            $scope.totalItemSize += $scope.defaultCart.length;
            $scope.totalItemSize += $scope.designCart.length;
            $scope.totalItemSize += $scope.emergencyCart.length;

            if($scope.totalItemSize > 0) {
                $scope.isEmpty = false;
            } else {
                $scope.isEmpty = true;
            }
        }

        var _changeCartType = function(cartType) {

            $scope.cartType = cartType;

            switch($scope.cartType) {
                case ShoppingCartService.cartTypeMap.defaultCart:
                    $scope.currentOrderitems = $scope.defaultCart;
                    break;
                case ShoppingCartService.cartTypeMap.designCart:
                    $scope.currentOrderitems = $scope.designCart;
                    break;
                case ShoppingCartService.cartTypeMap.emergencyCart:
                    $scope.currentOrderitems = $scope.emergencyCart;
                    break;
            }
        }

        // ------------------------------
        // 更改購物車類型
        // ------------------------------
        var changeCartType = function(cartType) {

            _changeCartType(cartType);
            refreshCartItem();
        }

        // -------------------------------
        // [private] 依造使用者記錄來決定預設運送方式
        // -------------------------------
        var initDelivery = function() {

            if($scope.oriuser && $scope.oriuser.contactInfo) {
                $scope.form.delivery = 1;
                $scope.form.postal = $scope.oriuser.contactInfo.postal;
                $scope.form.address = $scope.oriuser.contactInfo.address;
                $scope.form.name = $scope.oriuser.contactInfo.name;
                $scope.form.mobilephone = $scope.oriuser.contactInfo.mobilephone;
                $scope.form.phone = $scope.oriuser.contactInfo.phone;
                $scope.form.phoneExtension = $scope.oriuser.contactInfo.phoneExtension;
            } else {
                // $scope.form.delivery = 0;
            }

            changeDelivery($scope.form.delivery);
        }

        // -------------------------------
        // [private] 更改運送方式
        // -------------------------------
        var changeDelivery = function(delivery) {

            $scope.form.delivery = delivery;
            if($scope.form.delivery == 0) {
                $scope.form.shippingFee = 0;
            }

            refreshCartItem();
        }

        // -------------------------------
        // [private] 檢查價錢
        // -------------------------------
        var refreshCartItem = function() {

            $timeout(function() {
                var total = $scope.getTotalAmount();

                checkShippingFee(total);
                checkConfidentialFee();
                checkOfferProcess();
                checkPrintingType();
                checkbonusPointsDiscount(total);
            });
        }

        // -------------------------------
        // [private] 檢查運費
        // -------------------------------
        var checkShippingFee = function(total) {

            if(!$scope.currentOrderitems) {
                return;
            }

            var defaultTotal = ShoppingCartService.getTotalAmountWithProductDelivery($scope.cartType, ProductUtil.ProductDeliveryType.DEFAULT);
            var largeTotal = ShoppingCartService.getTotalAmountWithProductDelivery($scope.cartType, ProductUtil.ProductDeliveryType.LARGE);
            var onlySelfTotal = ShoppingCartService.getTotalAmountWithProductDelivery($scope.cartType, ProductUtil.ProductDeliveryType.ONLY_SELF);

            // 有限自取的商品，直接將配送方式轉為自取
            if(onlySelfTotal > 0) {
                $scope.hasOnlySelfTotal = true;
                $scope.form.delivery = OrderDeliveryType.SELF;
                $scope.form.isConfidentialDelivery = false;
            } else {
                $scope.hasOnlySelfTotal = false;
            }

            $scope.form.shippingFee = 0;
            $scope.form.defaultShippingFee = 0;
            $scope.form.largeShippingFee = 0;
            $scope.unknownLargeShippingFee = false;
            $scope.hasLargeProduct = largeTotal > 0;

            if($scope.form.delivery == OrderDeliveryType.SELF) {
                return;
            }

            var isFreeShipping = true;

            for(var i = 0 ; i < $scope.currentOrderitems.length ; i++){
                isFreeShipping = isFreeShipping && $scope.currentOrderitems[i].label == ProductUtil.ProductLabel.LABEL_FREE_SHIPPING;
            }

            $scope.isFreeShipping = isFreeShipping;

            var _otherShippingFee = 0;
            var _largeShippingFee = 0;
            var _unknownLargeShippingFee = false;

            if($scope.form.shippingFeeInfo) {
                _otherShippingFee = $scope.form.shippingFeeInfo.otherShippingFee || 0;
                _largeShippingFee = $scope.form.shippingFeeInfo.largeShippingFee || 0;
                _unknownLargeShippingFee = $scope.form.shippingFeeInfo.unknownLargeShippingFee;
            }

            // 巧昱沒有滿千免運以及預設88
            $scope.form.defaultShippingFee = 0;
            $scope.form.largeShippingFee = 0;
            // // 有大商品時，用專車費用計算
            // if (largeTotal > 0) {
            //     $scope.form.largeShippingFee = _largeShippingFee;
            // } else if(defaultTotal > 0) {
            //     // 全為一般商品，則用預設運費計算 (非偏遠地方時 全免運商品 或 總價大於一千，則免運)
            //     if(_otherShippingFee == 0 && (isFreeShipping || defaultTotal >= 1000)) {
            //         $scope.form.defaultShippingFee = 0;
            //     } else {
            //         $scope.form.defaultShippingFee = 88 + _otherShippingFee;
            //     }
            // }

            $scope.form.shippingFee = $scope.form.defaultShippingFee + $scope.form.largeShippingFee;
            $scope.unknownLargeShippingFee = _unknownLargeShippingFee;
        }

        // -------------------------------
        // [private] 檢查保密代寄
        // -------------------------------
        var checkConfidentialFee = function() {

            if($scope.form.delivery == OrderDeliveryType.HOME && $scope.form.isConfidentialDelivery) {
                $scope.form.confidentialFee = 0;
            } else {
                $scope.form.confidentialFee = 0;
            }
        }

        // -------------------------------
        // [private] 檢查是否有特殊加工
        // -------------------------------
        var checkOfferProcess = function() {

            if(!$scope.currentOrderitems) {
                return;
            }

            var hasOfferProcess = false;

            for(var i = 0 ; i < $scope.currentOrderitems.length ; i++){
                if($scope.currentOrderitems[i].spec 
                    && $scope.currentOrderitems[i].spec.offerProcess 
                    && $scope.currentOrderitems[i].spec.offerProcess.length > 0
                ) {
                    hasOfferProcess = true;
                    break;
                }
            }

            $scope.hasOfferProcess = hasOfferProcess;
        }

        // ------------------------------
        // [private] 檢查是否有特殊印刷
        // ------------------------------
        var checkPrintingType = function() {

            if(!$scope.currentOrderitems) {
                return;
            }

            var hasSpecialPrintingType = false;

            for(var i = 0 ; i < $scope.currentOrderitems.length ; i++){
                var item = $scope.currentOrderitems[i];
    
                if(item && item.spec && item.spec.specProps) {
                    var printingType = item.spec.specProps[ProductUtil.PdtSpecProps.PrintingType]

                    if(printingType === ProductUtil.PdtPrintingType.SCREEN_PRINTING) {
                        hasSpecialPrintingType = true;
                        break;
                    }
                }
            }

            $scope.hasSpecialPrintingType = hasSpecialPrintingType;
        }

        // -------------------------------
        // [private] 檢查紅利折抵金額
        // -------------------------------
        var checkbonusPointsDiscount = function(total) {

            if($scope.userBonusPoints.bonusRemainder == 0) {
                return;
            }

            var bonusPointsDiscount = Math.floor(total * 0.1);

            bonusPointsDiscount = Math.min(bonusPointsDiscount, $scope.userBonusPoints.bonusRemainder);

            $scope.form.bonusPointsDiscount = bonusPointsDiscount;
        }

        // -------------------------------
        // 取得購物車總數
        // -------------------------------
        var getShoppingCartItemSize = function() {

            return ShoppingCartService.getShoppingCartItemSize($scope.cartType);
        }

        // -------------------------------
        // 取得購物車總額
        // -------------------------------
        var getTotalAmount = function() {

            return ShoppingCartService.getTotalAmount($scope.cartType);
        }

        // -------------------------------
        // 點擊orderitem dropdown
        // -------------------------------
        var onOrderItemClick = function(orderitem) {

            $scope.currentOrderItem = orderitem;
        }

        // -------------------------------
        // 刪除購物車商品
        // -------------------------------
        var onRemoveShoppingCartClick = function(orderitem) {

            if(orderitem.isDeleting){
                return;
            }

            $rootScope.$broadcast('OPEN_LOADING_MODAL', {
                title: '正在從購物車刪除',
            });

            orderitem.isDeleting = true;
            var orderitemid = orderitem.orderitemid,
                cartType = $scope.cartType;

            ShoppingCartService.removeProductFromShoppingCart(orderitemid, cartType).then(function(result){
                if(result) {
                    var items;

                    switch(cartType) {
                        case ShoppingCartService.cartTypeMap.defaultCart:
                            items = $scope.defaultCart;
                            break;
                        case ShoppingCartService.cartTypeMap.designCart:
                            items = $scope.designCart;
                            break;
                        case ShoppingCartService.cartTypeMap.emergencyCart:
                            items = $scope.emergencyCart;
                            break;
                    }

                    if(items) {
                        for(var i = 0 ; i < items.length ; i++){
                            if(items[i].orderitemid == orderitemid){
                                items.remove(i);
                                break;
                            }
                        }
                    }

                    if((!$scope.designCart || $scope.designCart.length == 0)
                        && (!$scope.emergencyCart || $scope.emergencyCart.length == 0)
                    ) {
                        _changeCartType(ShoppingCartService.cartTypeMap.defaultCart);
                    }

                    getTotalItemSize();
                    refreshCartItem();

                    $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                        title: '成功從購物車刪除',
                    });

                } else {
                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '系統發生錯誤',
                    });
                }
            }, function(error){
                orderitem.isDeleting = false;

                $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                    title: '系統發生錯誤',
                });
            });
        }

        // -------------------------------
        // 取的購物車商品圖片
        // -------------------------------
        var getOrderItemCoverImage = function(orderitem) {

            if(!orderitem || !orderitem.coverurl){
                return "about:blank";
            }

            return orderitem.coverurl.replace("medium", "small");
        }

        // -------------------------------
        // [private] 檢查使用者資料
        // -------------------------------
        var checkUserInfo = function() {

            $scope.isUserNameEmpty = false;
            $scope.isUserMobilePhoneEmpty = false;
            $scope.isUserMobilePhoneError = false;
            $scope.isUserPhoneError = false;
            $scope.isUserAddressEmpty = false;

            if(!$scope.user.name) {
                $scope.isUserNameEmpty = true;
            }

            if(!$scope.user.mobilephone) {
                $scope.isUserMobilePhoneEmpty = true;
            }

            if($scope.user.mobilephone && !isPhone($scope.user.mobilephone)) {
                $scope.isUserMobilePhoneError = true;
            }

            if($scope.user.phone && !isPhone($scope.user.phone)) {
                $scope.isUserPhoneError = true;
            }

            if(!$scope.user.address) {
                $scope.isUserAddressEmpty = true;
            }

            if($scope.isUserNameEmpty || $scope.isUserMobilePhoneEmpty || $scope.isUserAddressEmpty) {
                $scope.isParamsMissing = true;
            }

            if($scope.isUserPhoneError || $scope.isUserMobilePhoneError) {
                $scope.isParamsError = true;
            }

            $scope.userInfoIsChange = true;

            if($scope.user == $scope.oriuser 
                || ($scope.user.name == $scope.oriuser.name 
                && $scope.user.mobilephone == $scope.oriuser.mobilephone 
                && $scope.user.phone == $scope.oriuser.phone 
                && $scope.user.phoneExtension == $scope.oriuser.phoneExtension
                && $scope.user.address == $scope.oriuser.address)) {

                $scope.userInfoIsChange = false;
            }
        }

        // -------------------------------
        // 新建訂單
        // -------------------------------
        var onOrderCreateClick = function() {

            if($scope.isCreating){
                return;
            }

            $scope.isOrderFileMissing = false;

            switch ($scope.cartType) {
                case ShoppingCartService.cartTypeMap.defaultCart:
                case ShoppingCartService.cartTypeMap.emergencyCart:
                    // 一般商品 ： 檢查檔案是否存在
                    for(var i = 0 ; i < $scope.currentOrderitems.length ; i++) {
                        var currentOrderitem = $scope.currentOrderitems[i];

                        // 實體商品、純文字修改不需要傳檔案
                        if(currentOrderitem.productShoppingType === ProductUtil.ProductShoppingType.STOCK_PAYMENT
                            || currentOrderitem.productShoppingType === ProductUtil.ProductShoppingType.ONLY_TEXT_REVIEW_PAYMENT_PRINT
                        ) {
                            continue;
                        }

                        currentOrderitem.isOrderFileMissing = false;

                        if(!currentOrderitem.userfileurl && !currentOrderitem.orgFile) {
                            currentOrderitem.isOrderFileMissing = true;
                            $scope.isOrderFileMissing = true;
                        }
                    }
                    break;
                case ShoppingCartService.cartTypeMap.designCart:
                default:
                    break;
            }

            // 若是訂單已經建立，就只需要實作上傳檔案的步驟即可
            if($scope.orderid) {
                $scope.isCreating = true;
                uploadOrderFile(0);
                return;  
            }

            $scope.isAddressEmpty = false;
            $scope.isNameEmpty = false;
            $scope.isMobilePhoneEmpty = false;
            $scope.isMobilePhoneError = false;
            $scope.isPostalEmpty = false;
            $scope.isPostalError = false;
            $scope.isSenderAddressEmpty = false;
            $scope.isSenderNameEmpty = false;
            $scope.isSenderMobilePhoneEmpty = false;
            $scope.isSenderMobilePhoneError = false;
            $scope.isSenderPostalEmpty = false;
            $scope.isSenderPostalError = false;
            $scope.invoiceTitleEmpty = false;
            $scope.VATNumberEmpty = false;
            $scope.VATNumberError = false;
            $scope.isDigitalCitizenCarrierIDEmpty = false;
            $scope.isDigitalCitizenCarrierIDError = false;
            $scope.isMobilePhoneCarrierIDEmpty = false;
            $scope.isMobilePhoneCarrierIDError = false;
            $scope.isLoveCodeEmpty = false;
            $scope.isInvoiceEmpty = false;
            $scope.isCompanyEmpty = false;
            $scope.isParamsMissing = false;
            $scope.isParamsError = false;

            checkUserInfo();

            // 檢查收件者地址是否有正確填入
            var _addressInfo = undefined;
            if($scope.form.delivery == 1) {
                if(!$scope.form.address) {
                    $scope.isAddressEmpty = true;
                    $scope.isParamsMissing = true;
                }

                if(!$scope.form.name) {
                    $scope.isNameEmpty = true;
                    $scope.isParamsMissing = true;
                }

                if(!$scope.form.mobilephone) {
                    $scope.isMobilePhoneEmpty = true;
                    $scope.isParamsMissing = true;
                }

                if($scope.form.mobilephone && !isPhone($scope.form.mobilephone)) {
                    $scope.isMobilePhoneError = true;
                    $scope.isParamsError = true;
                }

                if(!$scope.form.postal) {
                    $scope.isPostalEmpty = true;
                    $scope.isParamsMissing = true;
                }

                if($scope.form.postal && isNaN($scope.form.postal)) {
                    $scope.isPostalError = true;
                    $scope.isParamsError = true;
                }

                _addressInfo = {
                    name: $scope.form.name,
                    address: $scope.form.address,
                    postal: $scope.form.postal,
                    phone: $scope.form.phone,
                    mobilephone: $scope.form.mobilephone,
                    phoneExtension: $scope.form.phoneExtension,
                }
            }

            var _senderInfo = undefined;
            if($scope.form.isConfidentialDelivery) {
                if(!$scope.form.senderaddress) {
                    $scope.isSenderAddressEmpty = true;
                    $scope.isParamsMissing = true;
                }

                if(!$scope.form.sendername) {
                    $scope.isSenderNameEmpty = true;
                    $scope.isParamsMissing = true;
                }

                if(!$scope.form.sendermobilephone) {
                    $scope.isSenderMobilePhoneEmpty = true;
                    $scope.isParamsMissing = true;
                }

                if($scope.form.sendermobilephone && !isPhone($scope.form.sendermobilephone)) {
                    $scope.isSenderMobilePhoneError = true;
                    $scope.isParamsError = true;
                }

                if(!$scope.form.senderpostal) {
                    $scope.isSenderPostalEmpty = true;
                    $scope.isParamsMissing = true;
                }

                if($scope.form.senderpostal && isNaN($scope.form.senderpostal)) {
                    $scope.isSenderPostalError = true;
                    $scope.isParamsError = true;
                }

                _senderInfo = {
                    name: $scope.form.sendername,
                    address: $scope.form.senderaddress,
                    postal: $scope.form.senderpostal,
                    phone: $scope.form.senderphone,
                    mobilephone: $scope.form.sendermobilephone,
                    phoneExtension: $scope.form.senderphoneExtension,
                }
            }

            // 檢查發票資訊是否填寫正確
            if(!$scope.isBusinessMember) {

                if($scope.form.invoiceType === 'dualCopy' && !$scope.form.isDonate) {

                    if($scope.form.carrierType === 'digitalCitizenCarrier') {

                        if(!$scope.form.digitalCitizenCarrierID) {
                            $scope.isDigitalCitizenCarrierIDEmpty = true;
                            $scope.isParamsMissing = true;
                        } else if(!isDigitalCitizenCarrierID($scope.form.digitalCitizenCarrierID)) {
                            $scope.isDigitalCitizenCarrierIDError = true;
                            $scope.isParamsError = true;
                        }
                    }

                    if($scope.form.carrierType === 'mobilePhoneCarrier') {
                        if(!$scope.form.mobilePhoneCarrierID) {
                            $scope.isMobilePhoneCarrierIDEmpty = true;
                            $scope.isParamsMissing = true;
                        } else if(!isMobilePhoneCarrierID($scope.form.mobilePhoneCarrierID)) {
                            $scope.isMobilePhoneCarrierIDError = true;
                            $scope.isParamsError = true;
                        }
                    }
                } else if($scope.form.invoiceType === 'dualCopy' && $scope.form.isDonate) {
                    if($scope.form.selectLoveCode.code == '-1' && !$scope.form.loveCode) {
                        $scope.isLoveCodeEmpty = true;
                        $scope.isParamsMissing = true;
                    }
                } else if($scope.form.invoiceType === 'triCopy') {
                    if(!$scope.form.VATNumber) {
                        $scope.VATNumberEmpty = true;
                        $scope.isParamsMissing = true;
                    } else if(!isTaxIDNumber($scope.form.VATNumber)) {
                        $scope.VATNumberError = true;
                        $scope.isParamsError = true;
                    }

                    if(!$scope.form.invoiceTitle) {
                        $scope.invoiceTitleEmpty = true;
                        $scope.isParamsMissing = true;
                    }
                }
            } else {
                if(!isTaxIDNumber($scope.form.VATNumber)) {
                    $scope.VATNumberError = true;
                    $scope.isParamsError = true;
                }
            }
            
            $scope.mobilephoneExistedError = false;

            // 企業用戶不能更改手機
            if($scope.isBusinessMember) {
                _orderCreateCheckError(_addressInfo, _senderInfo);
            } else {
                UserService.checkMobilephone($scope.user.mobilephone).then(function(result) {
                    if(!result) {
                        $scope.mobilephoneExistedError = true;
                    }

                    _orderCreateCheckError(_addressInfo, _senderInfo);

                }, function(error) {
                    $scope.mobilephoneExistedError = true;

                    _orderCreateCheckError(_addressInfo, _senderInfo);
                })
            }
        }

        // -------------------------------
        // [private] 新建訂單前檢查是否有錯誤
        // -------------------------------
        var _orderCreateCheckError = function(_addressInfo, _senderInfo) {

            if($scope.isOrderFileMissing) {

                $timeout(function() {
                    var $errors = $('.button.file.error');

                    if($errors && $errors.length > 0) {
                        var scrollTo = $($errors[0]).offset().top;
                        
                        $('body').animate({ scrollTop: scrollTo - 150 }, 300);
                    }
                }, 100);

                return;
            } else if($scope.isParamsError || $scope.isParamsMissing || $scope.mobilephoneExistedError) {

                $timeout(function() {
                    var $errors = $('.error');

                    if($errors && $errors.length > 0) {
                        var scrollTo = $($errors[0]).offset().top;
                        
                        $('body').animate({ scrollTop: scrollTo - 150 }, 300);
                    }
                }, 100);

                return;
            }

            var description = '發票一但開立後將無法修改，確定是否建立訂單？';

            if(!checkIsPayFirst()) {
                // description = '部分商品含有「特殊加工」或是有「設計需求」或是「訂單需估專車運費」，該筆訂單需等稿件審核報價完才需付款';
                description = '部分商品含有「特殊加工」或是「網版印刷」，該筆訂單需等稿件審核報價完才需付款';
            }

            $rootScope.$broadcast('OPEN_CONFIRM_MODAL', {
                title: '確定建立訂單？',
                description: description,
                callback: function(confirm) {
                    if(confirm) {
                        _orderCreate(_addressInfo, _senderInfo);
                    }
                }
            });
        }

        // -------------------------------
        // [private] 新建訂單前更新會員資訊
        // -------------------------------
        var _orderCreate = function(_addressInfo, _senderInfo) {
            

            $rootScope.$broadcast('OPEN_LOADING_MODAL', {
                title: '正在建立訂單',
            });

            $scope.isCreating = true;
            $scope.isCreatingError = false;

            var delivery = $scope.form.delivery,                
                addressInfo = $scope.form.delivery == 1 ? JSON.stringify(_addressInfo):undefined,
                senderInfo = $scope.form.isConfidentialDelivery ? JSON.stringify(_senderInfo):undefined,
                isConfidentialDelivery = $scope.form.isConfidentialDelivery,
                invoiceTitle = $scope.form.invoiceType === 'triCopy' ? $scope.form.invoiceTitle:undefined,
                VATNumber = $scope.form.invoiceType === 'triCopy' ? $scope.form.VATNumber:undefined,
                paymentmethod = $scope.form.paymentmethod,
                remark = $scope.form.remark,
                cartType = $scope.cartType,
                bonusPointsDiscount = 0,
                isUseBonusPointsDiscount = $scope.form.isUseBonusPointsDiscount,
                invoiceType = $scope.form.invoiceType, 
                carrierType = $scope.form.carrierType, 
                loveCode = '',
                digitalCitizenCarrierID = $scope.form.digitalCitizenCarrierID, 
                mobilePhoneCarrierID = $scope.form.mobilePhoneCarrierID, 
                isDonate = $scope.form.isDonate;

            if($scope.form.isDonate) {
                loveCode = $scope.form.selectLoveCode.code == '-1' ? $scope.form.loveCode : $scope.form.selectLoveCode.code;
            }

            var orderitemids = [];

            for(var i = 0 ; i < $scope.currentOrderitems.length ; i++){
                orderitemids.push($scope.currentOrderitems[i].orderitemid);
            }

            if($scope.form.delivery == 1) {
                // 訂單完成時更新最後地址及常用地址清單
                UserService.updateContactInfo(addressInfo, senderInfo, $scope.form.isSaveAddress, $scope.form.isSaveSenderAddress);
            }

            // 如果第一次填寫統一編號資訊幫他存入個人資料
            if($scope.form.invoiceType === 'triCopy' && !$scope.oriuser.company && !$scope.oriuser.invoice) {
                $scope.user.company = invoiceTitle;
                $scope.user.invoice = VATNumber;
                $scope.userInfoIsChange = true;
            }

            // 先付款可以先折抵紅利
            if(isUseBonusPointsDiscount) {
                bonusPointsDiscount = $scope.form.bonusPointsDiscount;
            }
            
            var updateUserInfo = undefined;

            if($scope.userInfoIsChange) {

                // 企業用戶的更新用企業用戶的service
                if($scope.isBusinessMember) {
                    updateUserInfo = BusinessMemberService.updateInfo;
                } else {
                    updateUserInfo = UserService.updateUserInfo;
                }

                updateUserInfo($scope.user).then(function(result) {

                    if(result) {
                        $scope.userInfoIsChange = false;
                        $scope.oriuser = shallowCopy($scope.user);
                        orderCreate(delivery, senderInfo, addressInfo, isConfidentialDelivery, invoiceTitle, VATNumber, 
                                        paymentmethod, orderitemids, remark, cartType, bonusPointsDiscount, isUseBonusPointsDiscount,
                                        invoiceType, carrierType, loveCode, digitalCitizenCarrierID, mobilePhoneCarrierID, isDonate);
                    } else {
                        $scope.isCreating = false;
                        $scope.isCreatingError = true;

                        $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                            title: '系統發生錯誤',
                        });
                    }

                }, function(error) {

                    if(error && error.code === 'error.account.mobilephoneRepeat'){
                        $scope.mobilephoneExistedError = true;
                    } else {
                        $scope.isCreatingError = true;

                        $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                            title: '系統發生錯誤',
                        });
                    }

                    $scope.isCreating = false;
                });

            } else {
                orderCreate(delivery, senderInfo, addressInfo, isConfidentialDelivery, invoiceTitle, VATNumber, 
                                paymentmethod, orderitemids, remark, cartType, bonusPointsDiscount, isUseBonusPointsDiscount,
                                invoiceType, carrierType, loveCode, digitalCitizenCarrierID, mobilePhoneCarrierID, isDonate);
            }
        }

        // -------------------------------
        // [private] 新建訂單
        // -------------------------------
        var orderCreate = function(delivery, senderInfo, addressInfo, isConfidentialDelivery, invoiceTitle, VATNumber, paymentmethod, 
                                    orderitemids ,remark, cartType, bonusPointsDiscount, isUseBonusPointsDiscount, invoiceType, 
                                    carrierType, loveCode, digitalCitizenCarrierID, mobilePhoneCarrierID, isDonate) {

            OrderService.createOrderWithFullReturn(delivery, senderInfo, addressInfo, isConfidentialDelivery, invoiceTitle, VATNumber,
                                        paymentmethod, orderitemids, remark, cartType, bonusPointsDiscount, isUseBonusPointsDiscount,
                                        invoiceType, carrierType, loveCode, digitalCitizenCarrierID, mobilePhoneCarrierID, isDonate
            ).then(function(result){
                if(result) {
                    $scope.order = result;
                    $scope.orderid = result.orderid;
                    // $(window).scrollTop(0);
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                    sendEcommerceSuccess();
                    uploadOrderFile(0);

                    // 更新使用者統一發票使用記錄
                    if(invoiceTitle && VATNumber) {
                        UserService.updateLastInvoiceInfo($scope.user.mrscid, invoiceTitle, VATNumber);
                    }
                } else {
                    $scope.isCreating = false;
                    $scope.isCreatingError = true;

                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '系統發生錯誤',
                    });
                }
            }, function(error){     
                $scope.isCreating = false;
                $scope.isCreatingError = true;

                $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                    title: '系統發生錯誤',
                });
            });
        }

        // -------------------------------
        // [private] 發送成交成功事件
        // -------------------------------
        var sendEcommerceSuccess = function() {

            var orderid = $scope.orderid,
                mrscid = $scope.user.mrscid
                currentOrderitems = $scope.currentOrderitems;

            // 會先付款的流程才送ga資訊
            if($scope.order.productShoppingType === ProductUtil.ProductShoppingType.DEFAULT_PAYMENT_REVIEW_PRINT 
                || $scope.order.productShoppingType === ProductUtil.ProductShoppingType.STOCK_PAYMENT
            ) {
            
                var shippingFee = $scope.order.shippingFee;
                var totalSF = $scope.order.totalamount;
                var totalS = Math.round(totalSF / 1.05);
                var total = totalS - $scope.order.shippingFee;

                $InifECGA.sendEcommerceSuccess(mrscid, orderid, shippingFee, currentOrderitems, total, totalS, totalSF)
            }
        }

        // -------------------------------
        // [private] 稿件上傳
        // -------------------------------
        var uploadOrderFile = function(index) {

            if(index >= $scope.currentOrderitems.length) {
                // 重新拉購物車資訊
                $scope.currentOrderitems.length = 0;
                ShoppingCartService.getShoppingCart(true);

                
                $rootScope.$broadcast('CLOSE_LOADING_MODAL', {
                    orderid: $scope.orderid,
                });

                var needPay = $scope.order.productShoppingType === ProductUtil.ProductShoppingType.DEFAULT_PAYMENT_REVIEW_PRINT 
                                || $scope.order.productShoppingType === ProductUtil.ProductShoppingType.STOCK_PAYMENT;

                $rootScope.$broadcast('OPEN_ORDER_CREATE_SUCCESS_MODAL', {
                    orderid: $scope.orderid,
                    needPay: needPay,
                });
                return;
            }

            $scope.currentIndex = index;

            $scope.isCreating = true;
            $scope.isUploadFileError = false;
            var orderid = $scope.orderid,
                orderitem = $scope.currentOrderitems[index],
                orderitemid = orderitem.orderitemid,
                orgFile = orderitem.orgFile,
                userfileurl = orderitem.userfileurl;
            if(userfileurl){
                OrderService.uplaodOrderFileByUrl(orderid, orderitemid, userfileurl).then(function(result){
                    uploadOrderFile(++index);
                }, function(error){
                    $scope.isCreating = false;
                    $scope.isUploadFileError = true;
                    $rootScope.$broadcast('OPEN_ORDER_UPLOAD_ERROR_MODAL', {
                        orderid: $scope.orderid,
                    });
                    // 重新拉購物車資訊
                    ShoppingCartService.getShoppingCart(true);
                });
            } else if(orgFile) {
                 OrderService.uploadOrderItemFileByHistory(orderid, orderitemid).then(function(result){
                    uploadOrderFile(++index);
                }, function(error){
                    $scope.isCreating = false;
                    $scope.isUploadFileError = true;
                    $rootScope.$broadcast('OPEN_ORDER_UPLOAD_ERROR_MODAL', {
                        orderid: $scope.orderid,
                    });
                    // 重新拉購物車資訊
                    ShoppingCartService.getShoppingCart(true);
                });
            } else {
                uploadOrderFile(++index);
            }
        }

        // -------------------------------
        // 編輯商品規格
        // -------------------------------
        var changeOrderitemSpec = function(orderitem) {

            var currentOrderitems = $scope.currentOrderitems;

            $rootScope.$broadcast('OPEN_CHANGE_ORDERITEM_SPEC_MODAL', {
                orderitem: orderitem,
                callback: function(newitem) {
                    for(var i = 0; i < currentOrderitems.length; i++) {
                        if(currentOrderitems[i].orderitemid == newitem.orderitemid) {
                            currentOrderitems[i] = newitem;
                            break;
                        }
                    }

                    refreshCartItem();
                }
            })
        }

        // -------------------------------
        // 編輯使用者備註
        // -------------------------------
        var editUserRemark = function(orderitem) {

            $rootScope.$broadcast('OPEN_EDIT_USERREMARK_MODAL', {
                orderitem: orderitem,
                callback: function(userRemark) {
                    orderitem.userRemark = userRemark;
                },
                cartType: $scope.cartType,
            })
        }

        // -------------------------------
        // 上傳稿件
        // -------------------------------
        var uploadOrderitemFile = function(orderitem) {

            $rootScope.$broadcast('OPEN_UPLOAD_ORDERITEM_FILE_MODAL', {
                orderitem: orderitem,
                callback: function(userfileurl) {
                    orderitem.userfileurl = userfileurl;
                }
            });
        } 

        // -------------------------------
        // 編輯收件資訊
        // -------------------------------
        var editDelivery = function() {

            $rootScope.$broadcast('OPEN_EDIT_DELIVERY_MODAL', {
                // 收件人
                delivery: $scope.form.delivery,
                postal: $scope.form.postal,
                address: $scope.form.address,
                name: $scope.form.name,
                mobilephone: $scope.form.mobilephone,
                phone: $scope.form.phone,
                phoneExtension: $scope.form.phoneExtension,
                isSaveAddress: $scope.form.isSaveAddress,
                // 收件人錯誤狀態
                isAddressEmpty: $scope.isAddressEmpty,
                isNameEmpty: $scope.isNameEmpty,
                isMobilePhoneEmpty: $scope.isMobilePhoneEmpty,
                isMobilePhoneError: $scope.isMobilePhoneError,
                isPostalEmpty: $scope.isPostalEmpty,
                isPostalError: $scope.isPostalError,
                // 寄件人
                isConfidentialDelivery: $scope.form.isConfidentialDelivery,
                sendername: $scope.form.sendername,
                senderaddress: $scope.form.senderaddress,
                senderpostal: $scope.form.senderpostal,
                senderphone: $scope.form.senderphone,
                sendermobilephone: $scope.form.sendermobilephone,
                senderphoneExtension: $scope.form.senderphoneExtension,
                isSaveSenderAddress: $scope.form.isSaveSenderAddress,
                // 寄件人錯誤狀態
                isSenderNameEmpty: $scope.isSenderNameEmpty,
                isSenderMobilePhoneEmpty: $scope.isSenderMobilePhoneEmpty,
                isSenderMobilePhoneError: $scope.isSenderMobilePhoneError,
                isSenderPostalEmpty: $scope.isSenderPostalEmpty,
                isSenderPostalError: $scope.isSenderPostalError,
                isSenderAddressEmpty: $scope.isSenderAddressEmpty,

                isShowSaveButton: true,
                callback: function(delivery, addressInfo, isConfidentialDelivery, senderInfo, statusResult, shippingFeeInfo) {

                    if(delivery === undefined || addressInfo === undefined || statusResult === undefined) {
                        return;
                    }

                    if(isConfidentialDelivery && senderInfo === undefined) {
                        return;
                    }

                    $scope.form.delivery = delivery;
                    $scope.form.shippingFeeInfo = shippingFeeInfo;
                    $scope.form.isConfidentialDelivery = isConfidentialDelivery;

                    // 選擇宅配才更新目前資訊
                    if(delivery == 1) {
                        $scope.form.postal = addressInfo.postal;
                        $scope.form.address = addressInfo.address;
                        $scope.form.name = addressInfo.name;
                        $scope.form.mobilephone = addressInfo.mobilephone;
                        $scope.form.phone = addressInfo.phone;
                        $scope.form.phoneExtension = addressInfo.phoneExtension;
                        $scope.form.isSaveAddress = addressInfo.isSaveAddress;
                        // 錯誤狀態
                        $scope.isAddressEmpty = statusResult.isAddressEmpty;
                        $scope.isNameEmpty = statusResult.isNameEmpty;
                        $scope.isMobilePhoneEmpty = statusResult.isMobilePhoneEmpty;
                        $scope.isMobilePhoneError = statusResult.isMobilePhoneError;
                        $scope.isPostalEmpty = statusResult.isPostalEmpty;
                        $scope.isPostalError = statusResult.isPostalError;

                        // 選擇保密待寄才更新資料
                        if(isConfidentialDelivery) {
                            $scope.form.sendername = senderInfo.sendername;
                            $scope.form.senderaddress = senderInfo.senderaddress;
                            $scope.form.senderpostal = senderInfo.senderpostal;
                            $scope.form.senderphone = senderInfo.senderphone;
                            $scope.form.sendermobilephone = senderInfo.sendermobilephone;
                            $scope.form.senderphoneExtension = senderInfo.senderphoneExtension;
                            $scope.form.isSaveSenderAddress = senderInfo.isSaveSenderAddress;
                            // 錯誤狀態
                            $scope.isSenderNameEmpty = statusResult.isSenderNameEmpty;
                            $scope.isSenderMobilePhoneEmpty = statusResult.isSenderMobilePhoneEmpty;
                            $scope.isSenderMobilePhoneError = statusResult.isSenderMobilePhoneError;
                            $scope.isSenderPostalEmpty = statusResult.isSenderPostalEmpty;
                            $scope.isSenderPostalError = statusResult.isSenderPostalError;
                            $scope.isSenderAddressEmpty = statusResult.isSenderAddressEmpty;
                        }
                    }

                    changeDelivery($scope.form.delivery);
                }
            });
        }

        // -------------------------------
        // 編輯客戶資料
        // -------------------------------
        var editMember = function() {

            $rootScope.$broadcast('OPEN_EDIT_MEMBER_MODAL', {
                name: $scope.user.name,
                phone: $scope.user.phone,
                phoneExtension: $scope.user.phoneExtension,
                mobilephone: $scope.user.mobilephone,
                postal: $scope.user.postal,
                address: $scope.user.address,
                // 錯誤狀態
                isUserNameEmpty: $scope.isUserNameEmpty,
                isUserMobilePhoneEmpty: $scope.isUserMobilePhoneEmpty,
                isUserMobilePhoneError: $scope.isUserMobilePhoneError,
                isUserPhoneError: $scope.isUserPhoneError,
                isUserAddressEmpty: $scope.isUserAddressEmpty,
                mobilephoneExistedError: $scope.mobilephoneExistedError,
                isBusinessMember: $scope.isBusinessMember,
                callback: function(userInfo, statusResult) {

                    if(userInfo === undefined || statusResult === undefined) {
                        return;
                    }

                    $scope.user.name = userInfo.name;
                    $scope.user.phone = userInfo.phone;
                    $scope.user.phoneExtension = userInfo.phoneExtension;
                    $scope.user.mobilephone = userInfo.mobilephone;
                    $scope.user.postal = userInfo.postal;
                    $scope.user.address = userInfo.address;
                    // 錯誤狀態
                    $scope.isUserNameEmpty = statusResult.isUserNameEmpty;
                    $scope.isUserMobilePhoneEmpty = statusResult.isUserMobilePhoneEmpty;
                    $scope.isUserMobilePhoneError = statusResult.isUserMobilePhoneError;
                    $scope.isUserPhoneError = statusResult.isUserPhoneError;
                    $scope.isUserAddressEmpty = statusResult.isUserAddressEmpty;
                    $scope.mobilephoneExistedError = statusResult.mobilephoneExistedError;
                }
            });
        }

        // -------------------------------
        // 收件人資訊是否有誤
        // -------------------------------
        var isAddressInfoError = function() {

            return $scope.isAddressEmpty || $scope.isNameEmpty || $scope.isMobilePhoneEmpty || $scope.isMobilePhoneError 
                    || $scope.isPostalEmpty || $scope.isPostalError;
        }

        // -------------------------------
        // 客戶資訊是否有誤
        // -------------------------------
        var isUserInfoError = function() {

            return $scope.isUserNameEmpty || $scope.isUserMobilePhoneEmpty || $scope.isUserMobilePhoneError 
                    || $scope.isUserPhoneError || $scope.isUserAddressEmpty;
        }

        // --------------------------------
        // 上一頁
        // --------------------------------
        var goBack = function() {

            var backState = $PreviousState.getCartPrevious();

            $PreviousState.goBack(backState);
        }

        // --------------------------------
        // 開啟登入modal
        // --------------------------------
        var login = function() {

            $rootScope.$broadcast("OPEN_LOGIN_MODAL");
        }

        // --------------------------------
        // 檢查是不是企業用戶
        // --------------------------------
        var checkIsBusinessMember = function() {

            if($scope.oriuser.membertype == 1 && $scope.oriuser.businessmrscid) {
                $scope.isBusinessMember = true;

                changeInvoiceTypeAndDonate('triCopy', false);
            }
        }

        // --------------------------------
        // 取得一般加工總價
        // --------------------------------
        var getTotalProcessPrice = function(orderitem) {

            var price = ShoppingCartService.getTotalProcessPrice(orderitem);

            if(price < 0) {
                return 0;
            } else {
                return price;
            }
        }

        // --------------------------------
        // 取得商品總額
        // --------------------------------
        var getProductTotalPrice = function(orderitem) {

            var price = ShoppingCartService.getProductTotalPrice(orderitem);

            return price;
        }

        // -------------------------------
        // 取得預計出貨日
        // -------------------------------
        var getCartDelivery = function() {

            var cartDelivery = 0;

            if(!$scope.currentOrderitems || $scope.currentOrderitems.length == 0) {
                return cartDelivery;
            }

            for(var i = 0; i < $scope.currentOrderitems.length; i++) {
                var item = $scope.currentOrderitems[i];

                if(item.spec) {
                    var itemDelivery = parseInt(item.spec.deliveryDate / 86400000);
                    var processDelivery = ProductDeliveryService.getProcessDelivery(item.pdtClass, item.spec.process);
                    var specDelivery = ProductDeliveryService.getSpecDelivery(item.pdtClass, item.spec);
                    var totalDelivery = itemDelivery + processDelivery + specDelivery;

                    if(totalDelivery > cartDelivery) {
                        cartDelivery = totalDelivery;
                    }
                }
            }

            return cartDelivery;
        }

        // -------------------------------
        // 取得總價（呈現在畫面上的）
        // -------------------------------
        var getViewResultPrice = function() {

            if(!checkIsPayFirst()) {
                return '待報價';
            }

            var total = getTotalAmount();

            total += $scope.form.shippingFee;
            total += $scope.form.confidentialFee;

            if($scope.form.isUseBonusPointsDiscount) {
                total -= $scope.form.bonusPointsDiscount;
            }

            return window.Math.round(total * 1.05) + '元';
        }

        // -------------------------------
        // 是否先付款
        // -------------------------------
        var checkIsPayFirst = function() {

            return !$scope.hasOfferProcess && !$scope.hasSpecialPrintingType
                 && !$scope.unknownLargeShippingFee;
        }

        // -------------------------------
        // 是否使用紅利折抵
        // -------------------------------
        var toggleIsUseBonusPointsDiscount = function() {
            
            $scope.form.isUseBonusPointsDiscount = !$scope.form.isUseBonusPointsDiscount;
        }

        // ------------------------------
        // 更新發票選項
        // ------------------------------
        var changeInvoiceTypeAndDonate = function(invoiceType, isDonate) {

            $scope.form.invoiceType = invoiceType;
            $scope.form.isDonate = isDonate;

            if(isDonate) {
                changeCarrierType('memberCarrier');
            }
        }

        // ------------------------------
        // 更新發票種類
        // ------------------------------
        var changeCarrierType = function(carrierType) {

            $scope.form.carrierType = carrierType;
        }

        // ------------------------------
        // 判斷商品是否能上傳檔案
        // ------------------------------
        var isOrderItemCanUploadFile = function(orderitem) {

            return orderitem.productShoppingType != ProductUtil.ProductShoppingType.STOCK_PAYMENT
                && orderitem.productShoppingType != ProductUtil.ProductShoppingType.ONLY_TEXT_REVIEW_PAYMENT_PRINT;
        }

        // -------------------------------
        // [private] Init
        // -------------------------------
        var init = function() {
            if(!$rootScope.useNativeLoginModal){
                $rootScope.useNativeLoginModal = $stateParams.useNativeLoginModal;    
            }

            $scope.isLoading = true;
            UserService.getUserInfo().then(function(result) {

                if(result) {
                    $scope.user = shallowCopy(result);
                    $scope.form.invoiceTitle = $scope.user.company;
                    $scope.form.VATNumber = $scope.user.invoice;
                    $scope.oriuser = shallowCopy(result);
                    $scope.isLoading = false;

                    checkIsBusinessMember();
                    checkUserInfo();

                    if(!$scope.user.email) {
                        $rootScope.$broadcast("NO_EMAIL_NOTIFICATION");
                    }

                    // 非企業用戶才使用上次的發票資訊
                    if(!$scope.isBusinessMember && $scope.user.lastInvoiceInfo && $scope.user.lastInvoiceInfo.length > 0) {
                        var lastinfo = $scope.user.lastInvoiceInfo[$scope.user.lastInvoiceInfo.length - 1];
                        angular.extend($scope.form, lastinfo);

                        if(!$scope.form.invoiceType){
                            $scope.form.invoiceType = 'dualCopy';
                        }

                        if(!$scope.form.carrierType){
                            $scope.form.carrierType = 'memberCarrier';
                        }

                        if($scope.form.loveCode) {
                            for(var i = 0; i < $scope.loveCodeList.length; i++) {
                                if($scope.form.loveCode == $scope.loveCodeList[i].code) {
                                    $scope.form.selectLoveCode = $scope.loveCodeList[i];
                                    break;
                                }
                            }   
                        }
                    }
                    
                    getShoppingCart();
                    
                    $scope.isNoLogin = false;
                    
                } else {
                    $scope.isNoLogin = true;
                    $scope.isLoading = false;
                }
                
            }, function(error) {
                $scope.isNoLogin = true;
                $scope.isLoading = false;
            });
        }

	    //==========================
        //  Events
        //==========================
        $scope.$on('LOGIN_SUCCESS', function(event, data){
            init();
        });

        $scope.$watch('form.shippingFeeInfo', function(newValue, oldValue) {
            if(newValue !== undefined){
                refreshCartItem();
            }
        });

        //==========================
        //  Members
        //==========================
        $scope.order = undefined;
        $scope.orderid = undefined;
        $scope.isLoading = false;
        $scope.isError = false;
        $scope.isNoLogin = false;
        $scope.isLoad
        $scope.isCreating = false;
        $scope.currentOrderitems = undefined;

        $scope.cartTypeMap = ShoppingCartService.cartTypeMap;
        $scope.cartType = ShoppingCartService.cartTypeMap.defaultCart;
        $scope.totalItemSize = 0;
        $scope.defaultCart = ShoppingCartService.tmp_defaultCart;
        $scope.designCart = ShoppingCartService.tmp_designCart;
        $scope.emergencyCart = ShoppingCartService.tmp_emergencyCart;

        $scope.ProductShoppingType = ProductUtil.ProductShoppingType;

        $scope.form = {
            delivery: 1, // 運送方式, 0: 自取, 1: 宅配
            // addressInfo: {}, // 收件者
            postal: undefined, // 收件者郵遞區號
            address: undefined, // 收件者地址
            name: undefined, // 收件者名稱
            mobilephone: undefined, // 收件者手機
            phone: undefined, // 收件者市話
            phoneExtension: undefined, // 收件者分機
            // senderInfo: {}, // 寄件者
            senderpostal: undefined, // 保密代寄寄件人郵遞區號
            senderaddress: undefined, // 保密代寄寄件人地址
            sendername: undefined, // 保密代寄寄件人名稱
            sendermobilephone: undefined, // 保密代寄寄件人手機
            senderphone: undefined, // 保密代寄寄件人市話
            senderphoneExtension: undefined, // 保密代寄寄件人分機
            isConfidentialDelivery: false, // 是否為保密待機
            paymentmethod: 0, // 付費方式 1: ATM, 2: 信用卡,
            shippingFee: 0, // 運費
            remark: undefined, // 備註
            isSaveAddress: false, // 是否將收件資訊加入至常用地址清單
            isSaveSenderAddress: false, // 是否將寄件資訊加入至常用地址清單
            shippingFeeInfo: undefined,
            defaultShippingFee: 0, // 一般商品的運費（含偏遠費）
            largeShippingFee: 0, // 大商品專車運費
            confidentialFee: 0, // 保密代寄費用
            bonusPointsDiscount: 0, // 本次消費可用紅利
            isUseBonusPointsDiscount: true, // 是否要用紅利折抵

            // 發票相關
            invoiceTitle: undefined, // 發票標題
            VATNumber: undefined, // 發票號碼
            invoiceType: 'dualCopy',
            isDonate: false,
            carrierType: 'memberCarrier',
            loveCode: undefined,
            digitalCitizenCarrierID: undefined,
            mobilePhoneCarrierID: undefined,
            selectLoveCode: default_loveCodeList[0],
        };

        $scope.oriuser = undefined;
        $scope.user = undefined;
        $scope.Math = window.Math;
        $scope.Math = window.Math;
        $scope.currentIndex = 0;
        $scope.currentOrderItem = undefined;

        $scope.isParamsMissing = false;
        $scope.isParamsError = false;
        $scope.isAddressEmpty = false;
        $scope.isNameEmpty = false;
        $scope.isMobilePhoneEmpty = false;
        $scope.isMobilePhoneError = false;
        $scope.isPostalEmpty = false;
        $scope.isPostalError = false;
        $scope.isSenderAddressEmpty = false;
        $scope.isSenderNameEmpty = false;
        $scope.isSenderMobilePhoneEmpty = false;
        $scope.isSenderMobilePhoneError = false;
        $scope.isSenderPostalEmpty = false;
        $scope.isSenderPostalError = false;
        $scope.isOrderFileMissing = false;
        $scope.invoiceTitleEmpty = false;
        $scope.VATNumberEmpty = false;
        $scope.VATNumberError = false;
        $scope.isCreatingError = false;
        $scope.isUploadFileError = false;
        $scope.isFreeShipping = false;

        $scope.userInfoIsChange = false;
        $scope.isUserNameEmpty = false;
        $scope.isUserMobilePhoneEmpty = false;
        $scope.isUserMobilePhoneError = false;
        $scope.isUserPhoneError = false;
        $scope.isUserAddressEmpty = false;
        $scope.mobilephoneExistedError = false;
        $scope.hasOfferProcess = false;
        $scope.hasSpecialPrintingType = false;
        $scope.hasOnlySelfTotal = false;

        $scope.userBonusPoints = BonusPointsService.lastBonusPoints;
        $scope.unknownLargeShippingFee = false; // 該地區專車配送是否有定價
        $scope.hasLargeProduct = false; // 是否有大圖商品
        $scope.isDigitalCitizenCarrierIDEmpty = false;
        $scope.isDigitalCitizenCarrierIDError = false;
        $scope.isMobilePhoneCarrierIDEmpty = false;
        $scope.isMobilePhoneCarrierIDError = false;
        $scope.isLoveCodeEmpty = false;
        $scope.isInvoiceEmpty = false;
        $scope.isCompanyEmpty = false;
        $scope.loveCodeList = default_loveCodeList;
        $scope.SECURE_INIFEC_URL = SECURE_INIFEC_URL;

        //==========================
        //  Methods
        //==========================
        $scope.changeCartType = changeCartType; // 更改購物車類型
        $scope.getShoppingCartItemSize = getShoppingCartItemSize; // 取得購物車總數
        $scope.getTotalAmount = getTotalAmount; // 取得購物車總額
        $scope.onOrderItemClick = onOrderItemClick; // 點擊orderitem dropdown
        $scope.onRemoveShoppingCartClick = onRemoveShoppingCartClick; // 刪除購物車商品
        $scope.getOrderItemCoverImage = getOrderItemCoverImage; // 取的購物車商品圖片
        $scope.onOrderCreateClick = onOrderCreateClick; // 新建訂單
        $scope.changeOrderitemSpec = changeOrderitemSpec; // 編輯商品規格
        $scope.editUserRemark = editUserRemark; // 編輯使用者備註
        $scope.uploadOrderitemFile = uploadOrderitemFile; // 上傳稿件
        $scope.editDelivery = editDelivery; // 編輯收件資訊
        $scope.editMember = editMember; // 編輯客戶資料
        $scope.isAddressInfoError = isAddressInfoError; // 收件人資訊是否有誤
        $scope.isUserInfoError = isUserInfoError; // 客戶資訊是否有誤
        $scope.goBack = goBack; // 上一頁
        $scope.login = login; // 開啟登入modal
        $scope.getTotalProcessPrice = getTotalProcessPrice; // 取得一般加工總價
        $scope.getProductTotalPrice = getProductTotalPrice; // 取得商品總額
        $scope.getCartDelivery = getCartDelivery; // 取得預計出貨日
        $scope.getViewResultPrice = getViewResultPrice; // 取得總價（呈現在畫面上的）
        $scope.checkIsPayFirst = checkIsPayFirst; // 是否先付款
        $scope.toggleIsUseBonusPointsDiscount = toggleIsUseBonusPointsDiscount; // 是否使用紅利折抵
        $scope.changeInvoiceTypeAndDonate = changeInvoiceTypeAndDonate; // 更新發票選項
        $scope.changeCarrierType = changeCarrierType; // 更新發票種類
        $scope.isOrderItemCanUploadFile = isOrderItemCanUploadFile; // 判斷商品是否能上傳檔案

        //==========================
        //  Init
        //==========================
        init();
	}
]);